// extracted by mini-css-extract-plugin
export default {"tooltipTrigger":"GlossaryTooltip_tooltipTrigger__e6P9F","glossaryLink":"GlossaryTooltip_glossaryLink__szcsi","definitionText":"GlossaryTooltip_definitionText__2MImm"};